import { render } from "./trainingCourseTable.vue?vue&type=template&id=d49d2730&scoped=true&ts=true"
import script from "./trainingCourseTable.vue?vue&type=script&lang=ts"
export * from "./trainingCourseTable.vue?vue&type=script&lang=ts"

import "./trainingCourseTable.vue?vue&type=style&index=0&id=d49d2730&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d49d2730"]])

export default __exports__